import React, { Fragment } from 'react';
import Modal from './Modal';

const PaymentError = ({
  isOpen,
  message,
  onClose,
}) => {
  return (
    <Fragment>
      <Modal
        isOpen={isOpen}
        isClosable={false}
        onClose={onClose}
        Content={(
          <Fragment>
            <span className='error-modal-message'>
              결제 요청에 실패 하였습니다.
            </span>
            <span className='error-modal-sub-message'>
              {message}
            </span>
            <button className='confirm-button h-40 mb-14' onClick={onClose}>
              확인
            </button>
          </Fragment>
        )}
      />
    </Fragment>
  );
};

export default PaymentError;